import { __assign } from 'tslib';

function getTransitionConfig(size, animation, duration) {
    if (duration === void 0) { duration = 300; }
    if ("width" in size) {
        var width = size.width;
        return {
            from: { width: 0, zIndex: 10 },
            enter: { width: width },
            update: { width: width },
            leave: { width: 0 },
            config: __assign(__assign({}, animation), { duration: duration, clamp: true })
        };
    }
    else if ("height" in size) {
        var height = size.height;
        return {
            from: { height: 0, zIndex: 10 },
            enter: { height: height },
            update: { height: height },
            leave: { height: 0 },
            config: __assign(__assign({}, animation), { duration: duration, clamp: true })
        };
    }
    else {
        return {};
    }
}

export { getTransitionConfig };
//# sourceMappingURL=getTransitionConfig.esm.js.map
